import { debug } from "aaa";
import { IAPITarget, ITypedAPITarget } from "network-stapler";
import { User } from "models/User";
import { Loan } from "models/Loan";
import { Attachments } from "models/Attachment";
import * as _ from "lodash";

export interface IAuthToken {
    refreshToken: string;
    accessToken: string;
    expiresIn: number;
    tokenType: string;
    scopes: string[];
}

export function login(username: string, password: string): ITypedAPITarget<IAuthToken> {
    return {
        url: "/api/v1/auth/token",
        method: "POST",
        body: {
            grantType: "password",
            scope: "user",
            username: username,
            password: password
        },
        parse: json => json as IAuthToken
    };
}


export interface IRequestPasswordResponse {
    validUntil: Date;
}

export function requestPassword(username: string): ITypedAPITarget<IRequestPasswordResponse> {
    return {
        url: "/api/v1/auth/forgot-password",
        method: "POST",
        body: {
            username: username
        },
        parse: json => json as IRequestPasswordResponse
    };
}


export function setPassword(token: string, password: string): ITypedAPITarget<IAuthToken> {
    return {
        url: "/api/v1/auth/set-forgotten-password",
        method: "POST",
        body: {
            token,
            password
        },
        parse: json => json as IAuthToken
    };
}

export function changePassword(password: string): IAPITarget {
    return {
        url: "/api/v1/auth/change-password",
        method: "POST",
        body: {
            password
        }
    };
}


export function tokenRefresh(refreshToken: string): ITypedAPITarget<IAuthToken> {
    return {
        url: "/api/v1/auth/token",
        method: "POST",
        body: {
            refreshToken,
            grantType: "refreshToken"
        },
        parse: json => json as IAuthToken
    };
}


export interface IInterestSet {
    validFrom: string;
    interestInPercent: number[];
    interestEffectiveInPercent: number[];
    minAmount: number;
    maxAmount: number;
    minDuration: number;
    maxDuration: number;
    repExes: Array<{
        amount: number;
        payOut: number;
        initialAmortization: number;
        interest: number;
        interestEffective: number;
        monthlyRate: number;
        numRates: number;
        durationInYears: number;
        total: number;
    }>;
}


export interface IRepEx {
    repExText: string;
}

export function getInterestRates(): ITypedAPITarget<IInterestSet> {
    return {
        url: "/api/v1/interest-rates",
        parse: json => json as IInterestSet
    };
}


export function getInterestRatesUpcoming(): ITypedAPITarget<IInterestSet> {
    return {
        url: "/api/v1/interest-rates/upcoming",
        parse: json => json as IInterestSet
    };
}


export function getInterestRatesHistory(): ITypedAPITarget<{ xlsx: any }> {
    return {
        url: "/api/v1/interest-rates/history",
        parse: json => json as any
    };
}



export function postInterestRates(interestRates: {
    validFrom: string;
    interestInPercent: number[];
    interestEffectiveInPercent: number[];
}): IAPITarget {
    return {
        url: "/api/v1/interest-rates",
        method: "POST",
        body: interestRates
    };
}


export function postAttachment(file: File): IAPITarget {

    const fileExtension = file.name.split(".").pop();
    // .jpeg files are currently not accepted by BE, so we need to replace the extension
    if (fileExtension === "jpeg") {
        const fileName = file.name.replace(".jpeg", ".jpg");
        file = new File([file], fileName);
    }

    const data = new FormData();
    data.append("file", file);

    return {
        url: "/api/v1/attachments",
        method: "POST",
        body: data
    };
}

export function deleteAttachment(fileName: string): IAPITarget {

    return {
        url: "/api/v1/attachments",
        method: "DELETE",
        body: {
            file: fileName
        }
    };
}

export function postLoan(
    mailHtml: string,
    loan: Loan,
    user: User,
    attachments: Attachments): IAPITarget {

    const { amount, durationInYears, interestRate, totalAmount, monthlyRate } = loan;

    const { successfullySubmitted, ...restUser } = user;
    return {
        url: "/api/v1/loans",
        method: "POST",
        body: {
            mailHtml: mailHtml,
            data: {
                loan: {
                    amount, durationInYears, interestRate, totalAmount, monthlyRate
                },
                ...restUser,
                attachments: _.compact(attachments.attachments.map(entry => {
                    return {
                        fileName: entry.file.name,
                        uploadData: entry.uploadData
                    };
                }))
            }
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/network/api.ts